import { injectable } from "inversify";
import QARepository from "../../repositories/qa.repository";
import QAAgentEntity from "../../entities/qa_agent.entity";
import { Either, isLeft } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";
import SearchResultEntity from "../../entities/search_result.entity";

interface _Props {
    qaRepository: QARepository;
}
@injectable()
export default class SearchAgentsUseCase {
    private qaRepository: QARepository;
    constructor(props: _Props) {
        this.qaRepository = props.qaRepository;
    }
    public call = async (_: { query: string | undefined, page: number, itemsPerPage: number, operationId?: string }): Promise<Either<ErrorEntity, SearchResultEntity<QAAgentEntity>>> => {
        return this.qaRepository.searchAgents(_);
    }
}

export const SearchAgentsUseCaseName = "SearchAgentsUseCase";